import {FilterOption} from '@Components/DataGrid/DataGrid/FilterPopup/FilterPopup';

export function buildDateGroupOptions(
    arr: { value: string | number; name: string | number }[]
): FilterOption[] {
    // year → month → days
    const yearMap = new Map<string, Map<string, { value: string; name: string }[]>>();

    for (const item of arr) {
        const name = item.name as string; // dd.mm.yyyy
        const [, month, year] = name.split('.');
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        const monthLabel = monthNames[parseInt(month, 10) - 1];

        if (!yearMap.has(year)) yearMap.set(year, new Map());
        const monthMap = yearMap.get(year)!;

        if (!monthMap.has(monthLabel)) monthMap.set(monthLabel, []);
        monthMap.get(monthLabel)!.push({ value: item.value as string, name });
    }

    const result: FilterOption[] = [];

    for (const [year, monthMap] of yearMap) {
        const monthOptions: FilterOption[] = [];

        for (const [monthLabel, days] of monthMap) {
            monthOptions.push({
                name: monthLabel,
                value: `group_month_${year}_${monthLabel}`,
                isGroup: true,
                children: days.map(d => ({
                    name: d.name,
                    value: d.value,
                    isGroup: false
                }))
            });
        }

        result.push({
            name: year,
            value: `group_year_${year}`,
            isGroup: true,
            children: monthOptions
        });
    }

    return result;
}